// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeContestMakeupReviewGetBody = {
  poolId: string;
  contestId: string;
};

export type typeContestMakeupReviewGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    contestId: string;
    reviewToken: string;
    outstandingPickCount: number;
    affectedEntryCount: number;
    firstSourceRoundNumber: number | null;
    canWaive: boolean;
  };
};

export type typeContestMakeupReviewGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeContestMakeupReviewGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeContestMakeupReviewGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaContestMakeupReviewGetBody = {
  type: "object",
  properties: {
    poolId: { type: "string", minLength: 1, maxLength: 3000 },
    contestId: { type: "string", minLength: 1, maxLength: 3000 },
  },
  required: ["poolId", "contestId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createContestMakeupReviewGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaContestMakeupReviewGetBody);
  }

  return async function postContestMakeupReviewGet(
    payload: typeContestMakeupReviewGetBody,
  ): Promise<
    typeContestMakeupReviewGetOutput200 | typeContestMakeupReviewGetOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postContestMakeupReviewGet" failed before calling the network. #62141cf9bbf4`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#62141cf9bbf4" },
        },
        data: null,
      } as typeContestMakeupReviewGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/contest/makeup-review-get`,
      httpMethod: "POST",
      options,
    })) as
      typeContestMakeupReviewGetOutput200 | typeContestMakeupReviewGetOutput400;
  };
}
